import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type DeclaredNodePayload = {
	readonly uuid: string;
	readonly path: string;
	readonly name: string;
	readonly isList: boolean;
	readonly order: number;
};

// `type` passes through `TemplateFieldType`, with a `{ value, label: value }` fallback for an unknown
// value — always an object on the wire, never a bare string.
export type DeclaredFieldPayload = {
	readonly uuid: string;
	readonly path: string;
	readonly label: string;
	readonly type: LabeledValuePayload;
	readonly isRequired: boolean;
	readonly order: number;
};

// The declaration itself: possibly-empty arrays, sorted by `order` then `path` server-side. This shape
// is also the `201` response of the first upload and of a new version — reused there rather than
// duplicated.
export type DocumentTemplateVersionDetailPayload = {
	readonly id: number;
	readonly template: { readonly id: number };
	readonly versionNumber: number;
	readonly originalFilename: string;
	readonly fieldCount: number;
	readonly createdAt: string;
	// UUIDs of the top-level declared nodes marked for reevaluation.
	readonly reevaluationSectionKeys: string[];
	// French sentences describing section dependencies that do not apply to the template; empty when none.
	readonly sectionDependencyWarnings: string[];
	readonly declaration: {
		readonly nodes: DeclaredNodePayload[];
		readonly fields: DeclaredFieldPayload[];
	};
};

export type DocumentTemplateVersionFetchedPayload = DocumentTemplateVersionDetailPayload;

export type DocumentTemplateVersionFetchedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSION_FETCHED';
	payload: DocumentTemplateVersionFetchedPayload;
};

export default (payload: DocumentTemplateVersionFetchedPayload): DocumentTemplateVersionFetchedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSION_FETCHED',
	payload,
});
